/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PatternMatchType = {
    Match: 'must_match',
    NotMatch: 'must_not_match'
} as const;
export type PatternMatchType = typeof PatternMatchType[keyof typeof PatternMatchType];


export function PatternMatchTypeFromJSON(json: any): PatternMatchType {
    return PatternMatchTypeFromJSONTyped(json, false);
}

export function PatternMatchTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatternMatchType {
    return json as PatternMatchType;
}

export function PatternMatchTypeToJSON(value?: PatternMatchType | null): any {
    return value as any;
}

